import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import __ from 'localisation';
import { useAuth } from '../../contexts/AuthContext';

const Layout = (props) => {
  const { authToken } = useAuth();
  const { layout: TheLayout, auth = true, ...restProps } = props;

  useEffect(() => {
    // Update the document title using the browser API
    document.title = props.title ? props.title + ' - ' + __('app_name') : __('app_name');
  }, [props.title]);

  if (auth) {
    if (!authToken) {
      return <Redirect to={'/'} />;
    }
  }

  return <TheLayout auth={auth} {...restProps} />;
};

export default Layout;
